<template>
  <ul :class="$style.counters">
    <template
      v-for="(channelText, channelId) in channelLabelMap"
      :key="channelId"
    >
      <li :class="$style.counters__item" v-if="amountItemMap[channelId]">
        <div :class="$style.counter">
          <span :class="$style.counter__channel">{{ channelText }}</span>
          <KartePlannerCommentMonthlyAmountCounter
            :class="$style.counter__usage"
            :usage="amountItemMap[channelId]?.usage ?? 0"
            :upperLimit="amountItemMap[channelId]?.upperLimit ?? undefined"
          />
        </div>
      </li>
    </template>
  </ul>
</template>

<script setup lang="ts">
import type { ComputedRef } from 'vue'
import { computed } from 'vue'
import { Channel } from '@/types/schema.generated'
import KartePlannerCommentMonthlyAmountCounter from './KartePlannerCommentMonthlyAmountCounter.vue'
import type {
  V2021_1KartePlannerCommentMonthlyAmountFragment,
  V2021_1KartePlannerCommentMonthlyAmountItemFragment,
} from './KartePlannerCommentMonthlyAmountV20211.generated'
import { channelLabelMap } from '@/models/channel/channel'

const props = defineProps<{
  amount: Maybe<V2021_1KartePlannerCommentMonthlyAmountFragment>
}>()

const amountItemMap: ComputedRef<
  Partial<Record<Channel, V2021_1KartePlannerCommentMonthlyAmountItemFragment>>
> = computed(() => {
  const itemEntries = props.amount?.items.map(
    item => [item.channel, item] as const
  )
  if (!itemEntries) {
    return {}
  }

  return Object.fromEntries(itemEntries) as Partial<
    Record<Channel, V2021_1KartePlannerCommentMonthlyAmountItemFragment>
  >
})
</script>

<style lang="scss" module>
.counters {
  display: flex;

  &__item {
    &:nth-child(n + 2) {
      margin-left: 16px;
    }

    &:nth-last-child(n + 2) {
      padding-right: 16px;
      border-right: 1px dashed $color-border-low-emphasis;
    }
  }
}

.counter {
  display: flex;
  align-items: center;

  &__channel {
    font-size: 12px;
    line-height: 1em;
  }

  &__usage {
    &:nth-child(n + 2) {
      margin-left: 12px;
    }
  }
}
</style>
